import { Component } from 'react'

import { graphql } from '@apollo/client/react/hoc'
import { Col, Row, Input } from 'reactstrap'
import CreateUpdateMemberModal from "./CreateUpdateMemberModal"
import UpdateMembers from "./UpdateMembers"
import { HasPermissionsQuery } from "../../Functions/querys"
import AdvancedFiltersControl from '../../Filters/AdvancedFiltersControl'
import AppliedAdvancedFilters from '../../Filters/AppliedAdvancedFilters'

import withApolloClient from '../../withApolloClient'

class MembersListHeader extends Component {
    constructor(props) {
        super(props)
        this.state = {
            openModal: "",
        }
    }
    toggleModal = (modalName) => {
        this.setState({ openModal: this.state.openModal === modalName ? "" : modalName })
    }
    updateSearchTerm = (searchTerm) => {
        this.props.setFilterValues({ ...this.props.filterValues, searchTerm })
    }
    render() {
        return (
            <Row className="pb-3 align-items-center">
                <Col xs={4}>
                    <span className="driver-search-filter">
                        <Input type="text" name="searchTerm" placeholder="Search" onChange={(e) => this.updateSearchTerm(e.target.value)} />
                        <i className="fa fa-lg fa-search search-icon" aria-hidden="true"></i>
                    </span>
                </Col>
                <Col xs="auto" className="p-0">
                    {this.props.showView === "membersList" && <AdvancedFiltersControl entity="member" presets={this.props.presets} setPresets={this.props.setPresets} defaultPresets={this.props.defaultPresets} />}
                </Col>
                {this.state.openModal === ("AssignGroup") && <UpdateMembers handleClose={() => this.toggleModal("")} isOpen={this.state.openModal === ("AssignGroup")} refetchQuery={() => this.props.refetchQuery()} memberDetails={this.props.selectedMembers} />}
                {this.state.openModal === ("BulkMemberBrnachUpdate") && <CreateUpdateMemberModal handleClose={() => this.toggleModal("")} isOpen={this.state.openModal === ("BulkMemberBrnachUpdate")} refetchQuery={() => this.props.refetchQuery()} memberDetails={this.props.selectedMembers} action={""} isMultiUpdate={true} isUpdate branchId={""} />}
                {this.state.openModal === ("AddMember") && <CreateUpdateMemberModal handleClose={() => this.toggleModal("")} isOpen={this.state.openModal === ("AddMember")} refetchQuery={() => this.props.refetchQuery()} memberDetails={""} action={""} isMultiUpdate={false} branchId={""} />}
                <Col className="text-right">
                    {this.props.selectedMembers && this.props.selectedMembers.length > 0 && this.props.hasPermissions && this.props.hasPermissions.includes("custom_can_edit_member_sensitive_info") &&
                        <>
                            <a className="driver-list-button" onClick={() => this.toggleModal("AssignGroup")}>
                                Assign Group | <i className="fa fa-plus" aria-hidden="true"></i>
                            </a>&nbsp;&nbsp;&nbsp;&nbsp;
                        </>
                    }
                    {this.props.selectedMembers && this.props.selectedMembers.length > 0 && this.props.hasPermissions && this.props.hasPermissions.includes("change_member") ?
                        <>
                            <a className="driver-list-button" onClick={() => this.toggleModal(("BulkMemberBrnachUpdate"))}>
                                Update Selected Members | <i className="fa fa-edit" aria-hidden="true"></i>
                            </a>&nbsp;&nbsp;&nbsp;&nbsp;
                        </> :
                        this.props.showView === "membersList" && <>
                            <a className="driver-list-button" onClick={() => this.toggleModal("AddMember")}>
                                Add Member | <i className="fa fa-plus" aria-hidden="true"></i>
                            </a>&nbsp;&nbsp;&nbsp;&nbsp;
                        </>
                    }
                    {this.props.showView === "membersList" && this.props.hasPermissions && this.props.hasPermissions.includes("custom_can_edit_member_sensitive_info") &&
                        <a className="driver-list-button" onClick={() => this.props.changeView("createUserBtn")}>
                            Create User | <i className="fa fa-user-plus" aria-hidden="true"></i>
                        </a>
                    }
                    {this.props.showView != "membersList" &&
                        <a className="driver-list-button" onClick={() => this.props.changeView("membersList")}>
                            Members List | <i className="fa fa-users" aria-hidden="true"></i>
                        </a>
                    }
                </Col>
                <Col xs={12} className="mt-2 search-filter-container">
                    {this.props.showView === "membersList" && <AppliedAdvancedFilters
                        entity="member"
                        context={null}
                        presets={this.props.presets}
                        onPresetsChange={this.props.setPresets}
                    />}
                    {this.props.selectedMembers && this.props.selectedMembers.length > 0 && <span className="search-filter-preview">
                        <span> <i className="fa fa-times-circle" onClick={this.props.resetSelectedMembers}></i> &nbsp;&nbsp; Selected Members</span>
                        {this.props.selectedMembers.length}
                    </span>}
                </Col>
            </Row>
        )
    }
}


//-----------------------------------
export default graphql(HasPermissionsQuery, {
    options: () => ({
        variables: { userPermissions: ["custom_can_edit_member_sensitive_info", "change_member"] }, fetchPolicy: "network-only", notifyOnNetworkStatusChange: true
    }),
    props: ({ data: { hasPermissions, loading, variables } }) => ({
        hasPermissions, loading, variables
    })
})(withApolloClient(MembersListHeader))
